export interface Property {
  id: string;
  name: string;
  address: string;
  type: string;
  status: string;
  asset_count: number;
  survey_date?: string;
  compliance_score?: number;
  facility_image_url?: string;
}

export type PropertyDetailFields = {
  project_status?: string | null;
  facility_image_url?: string | null;
};

export const PROPERTY_TAB_VALUES = [
  'overview',
  'assets',
  'site-attributes',
  'photos',
  'vr',
  'files-documents',
  'deficiencies',
  'exports',
] as const;

export type PropertyTab = typeof PROPERTY_TAB_VALUES[number];

export function isPropertyTab(value: string | null): value is PropertyTab {
  return value != null && (PROPERTY_TAB_VALUES as readonly string[]).includes(value);
}

export function getPropertyTabFromParam(value: string | null): PropertyTab {
  if (value === "report") return "photos";
  if (value === "3d") return "files-documents";
  return isPropertyTab(value) ? value : "overview";
}

export function getStatusColor(status: string): string {
  switch (status.toLowerCase()) {
    case 'active':
      return 'bg-status-success text-status-success-text border-status-success-border';
    case 'maintenance':
      return 'bg-status-warning text-status-warning-text border-status-warning-border';
    case 'planning':
      return 'bg-status-info text-status-info-text border-status-info-border';
    default:
      return 'bg-muted text-muted-foreground border-border';
  }
}

export interface PropertyListItem {
  id: string;
  name: string;
  address: string;
  type: string;
}
